/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { assetImages } from "constants";

const SuccessTemplateModal = ({ afterSaveTeamplateModalClose, moduleName }) => {
  //** Language translation */
  const { t } = useTranslation();

  return (
    <div
      className="modal fade"
      id="afterSaveTemplateModal"
      tabIndex="-1"
      aria-labelledby="saveInfoLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-body text-center p-5">
            <img
              src={assetImages.congratulationsIcon}
              alt="You have saved a lead successfuly."
              className="img-fluid mb-2"
            />
            <h2 className="mb-2">{t("Congratulations")}</h2>
            <p className="fs-lg fw-semibold mb-5">
              {t("You have saved a template successfuly")}.
            </p>
            <div className="action d-flex justify-content-center gap-3">
              <Link
                to="#"
                data-bs-dismiss="modal"
                className="btn btn-outline-primary"
                onClick={() => {
                  if (moduleName === "CRM") {
                    afterSaveTeamplateModalClose(
                      "/admin/crm/mailtemplate/list"
                    );
                  } else if (moduleName === "administration") {
                    afterSaveTeamplateModalClose(
                      "/admin/administration/mailtemplate/list"
                    );
                  } else {
                  }
                }}
              >
                {t("Go to List")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessTemplateModal;
